import React from 'react'
import { Link } from 'react-router-dom'
import img1 from '../../../assets/img/pharmacy/banner/banner1.jpg'
import img2 from '../../../assets/img/pharmacy/banner/banner.jpeg'
import video from '../../../assets/img/pharmacy/banner/banner.mp4'
import video2 from '../../../assets/img/pharmacy/banner/aecmc.mp4'
import playbtn from '../../../assets/img/pharmacy/banner/playbtn.png'

import ReactPlayer from 'react-player/lazy'
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { Carousel } from 'react-bootstrap'

const PharmacyBanner = (props) => {

    return (
        <>
            <div id="pharmacy_banner">

                <div className="row">
                    <div className="col-lg-12">


                        <Carousel controls={true} nextLabel="" prevLabel="" variant="dark">
                            <Carousel.Item >
                                <ReactPlayer

                                    url={video2}
                                    width="100%"
                                    className="react-player"
                                    playing
                                    playIcon={<img src={playbtn} style={{ height: 90 }} />}
                                    light={isMobile ? false : img2}
                                    loop={true}
                                    volume={0.1}
                                    controls={true}
                                    playsinline={true}
                                />
                            </Carousel.Item>
                            {/* <Carousel.Item >
                                <ReactPlayer

                                    url={video}
                                    width="100%"
                                    className="react-player"
                                    playing
                                    playIcon={<img src={playbtn} style={{ height: 90 }} />}
                                    light={isMobile ? false : img1}
                                    loop={true}
                                    volume={0.1}
                                    controls={true}
                                    playsinline={true}
                                />
                            </Carousel.Item> */}
                        </Carousel>
                        {/* <Carousel controls={true} nextLabel="" prevLabel="" variant="dark">
                                {props?.offerSlides?.map((data, index) => (<Carousel.Item key={index}>
                                    <img
                                        className="d-block w-100"
                                        src={process.env.REACT_APP_IMG_URL+data}
                                      
                                    />
                                </Carousel.Item>))}
                            </Carousel> */}


                    </div>
                    {/* <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-12 col-md-6 col-sm-6 col-12">
                                    <div className="pharmacy_banner_img banner_last_img">
                                    <Carousel controls={false}>
                                {props?.eventSlides?.map((data, index) => (<Carousel.Item key={index}>
                                    <img
                                        className="d-block w-100"
                                        src={data}
                                        style={{height:300}}
                                    />
                                </Carousel.Item>))}
                            </Carousel>
                                      
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-6 col-sm-6 col-12">
                                
                                    <div className="pharmacy_banner_img banner_last_img">
                                        <Link to="/estore">
                                            <img src={img3} alt="img" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                </div>

            </div>
        </>
    )
}
export default PharmacyBanner